/**
 * Validation-related constants
 */

export const VALIDATION_PATTERNS = {
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
} as const;

export const COORDINATE_LIMITS = {
  LATITUDE_MIN: -90,
  LATITUDE_MAX: 90,
  LONGITUDE_MIN: -180,
  LONGITUDE_MAX: 180,
} as const;

/** Maximum length for address input to prevent abuse */
export const ADDRESS_MAX_LENGTH = 500;

export const VALIDATION_MESSAGES = {
  INVALID_EMAIL: 'Invalid Email',
  INVALID_NUMBER: 'Must be a valid number',
  INVALID_LOCATION: 'Must be in format "lat, lng"',
  INVALID_LATITUDE: 'Invalid latitude',
  INVALID_LONGITUDE: 'Invalid longitude',
  ADDRESS_REQUIRED: 'Address is required',
  LATITUDE_REQUIRED: 'Latitude is required',
  LONGITUDE_REQUIRED: 'Longitude is required',
} as const;
